import { render, staticRenderFns } from "./GiftCardComingSoonModal.vue?vue&type=template&id=79dd0f4e&scoped=true&"
import script from "./GiftCardComingSoonModal.vue?vue&type=script&lang=js&"
export * from "./GiftCardComingSoonModal.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardComingSoonModal.vue?vue&type=style&index=0&id=79dd0f4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dd0f4e",
  null
  
)

export default component.exports